:host {
    a {
        color: $polaris-color-teal5;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }

    ti-card {
        &-container {
            padding: $polaris-space-4;
        }
    }
    .new-badge {
        color: #c00;
        font-size: 12px;
        line-height: 20px;
        font-weight: 500;
        text-transform: uppercase;
        text-decoration: none;
        line-height: 24px;
        margin-right: $polaris-space-2;
    }
    .new-badge-tool {
        color: #c00;
        font-size: 12px;
        line-height: 20px;
        font-weight: 500;
        text-transform: uppercase;
        text-decoration: none;
        line-height: 24px;
    }
    .ti-gpn-snapshot {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        @include mix-for-sizes-down(phone) {
            flex-direction: column;
            margin: -8px -8px 0;
        }
        &-fixed {
            display: flex;
            flex-direction: column;
            max-width: 470px;
        }
        &-data-sheet {
            display: flex;
            align-items: baseline;
            margin-top: 0;
            margin-bottom: $polaris-space-4;
            > a,
            > span {
                align-items: center;
                display: flex;
                margin-right: $polaris-space-2;
            }
            div {
                display: flex;
            }
            > a {
                margin-right: $polaris-space-2;
            }
            .ti-gpn-snapshot-divider {
                display: inline;
                padding: 0 $polaris-space-2 0 0;
            }
            @include mix-for-sizes-up(tablet) {
                margin-top: $polaris-space-1;
                margin-bottom: 0;
            }
        }
        &-view-alternates {
            margin-top: $polaris-space-4;
            margin-bottom: $polaris-space-2;

            @include mix-for-sizes-up(tablet) {
                margin-bottom: 0;
            }

            .ti_p-iconText {
                display: flex;
                align-items: center;
                cursor: pointer;
                appearance: none;
                background: transparent;
                border: 0;
                padding: 0;
                color: $pl-link-color-primary;
                font-size: $polaris-font-size-2;

                &:hover {
                    text-decoration: underline;
                }

                .ti_p-iconText-icon {
                    margin-right: $polaris-space-2;
                }
            }
        }
        &-quicklinks {
            width: 250px;
            ti-button {
                width: 100%;
                margin-bottom: $polaris-space-4;
                &.ti-gpn-snapshot-order-button {
                    margin-top: $polaris-space-4;
                }
            }
            @include mix-for-sizes-down(phone) {
                width: 100%;
                margin-top: $polaris-space-2;
            }
        }
        &-product-family-link {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: baseline;
        }
    }
    .ti-gpn-snapshot-opn-list {
        margin-top: $polaris-space-8;
        border-top: 1px solid $polaris-color-grey2;
        @include mix-for-sizes-down(phone) {
            margin-left: -$polaris-space-2;
            margin-right: -$polaris-space-2;
            margin-top: $polaris-space-6;
        }
    }

    .ti-gpn-snapshot-progress {
        display: flex;
        justify-content: center;
        padding: $polaris-space-8 $polaris-space-8 $polaris-space-2;
    }

    .ti-gpn-snapshot-opn-list-content-view-all {
        display: flex;
        flex-direction: column;
        align-items: baseline;
        margin-top: $polaris-space-8;

        &-product-family-link {
            display: flex;
            flex-direction: row;
            align-items: baseline;

            ti-button {
                margin-right: $polaris-space-6;
            }

            @include mix-for-sizes-down(phone) {
                flex-wrap: wrap;
                width: 100%;

                ti-button {
                    width: 100%;
                    margin: 0 0 $polaris-space-4 0;
                }
            }
        }

        ti-svg-icon {
            padding-right: $polaris-space-2;
        }
        @include mix-for-sizes-down(phone) {
            flex-wrap: wrap;
            margin-top: $polaris-space-6;
        }
    }
    .ti-gpn-snapshot-opn-list-expander {
        appearance: none;
        font-family: $polaris-font-family-roboto;
        font-size: $polaris-font-size-2;
        border: none;
        background: transparent;
        display: inline-flex;
        align-items: center;
        cursor: pointer;
        color: $polaris-color-teal5;
        white-space: nowrap;
        ti-svg-icon {
            margin-left: $polaris-space-1;
            transition: transform .15s $polaris-animation-easing-smooth;
        }
        &.collapsed {
            ti-svg-icon {
                transform: rotate(180deg);
            }
        }
    }
}
